module.exports = __webpack_public_path__ + "static/media/filter.258af22b.svg";